<template>
  <div class="message-box smooth-shadow">
    <div class="message-box-header">
      <icon>square_foot</icon>
      <div class="flex-col">
        <h3>Measure Distance Mode</h3>
        <p>Click anywhere on map to start measuring distance.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.message-box {
  display: flex;
  flex-direction: column;
  background: var(--color-secondary);
  width: 300px;
  border: 1px solid var(--border-color);
  border-radius: 5px;
  position: absolute;
  top: 12px;
  z-index: 99;
  left: 0;
  right: 0;
  margin: 0 auto;

  .message-box-header {
    display: flex;
    flex-direction: row;
    padding: 15px 15px 5px 20px;
    align-items: flex-start;

    i {
      margin-right: 10px;
      padding: 10px;
      background: var(--color-primary-light);
      color: var(--color-primary);
      border-radius: 50%;
    }
  }

  h3 {
    margin-top: 5px;
    color: var(--color-primary);
  }

  p {
    padding: 5px 15px 10px 0;
    margin: 0;
    opacity: 0.7;
  }
}
</style>
